import React from 'react';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import OnlineStatus from './OnlineStatus';

const UserBadge = ({ userId, className, ...rest }) => {
  const users = useSelector(state => state.chat.users);
  const user = users.find(u => u.id === userId);

  if (!user) {
    return null;
  }

  return (
    <div className={classNames('user-badge d-inline-block', className)} {...rest}>
      <OnlineStatus className="d-inline-block" status={user.status} /> {user.displayName}
    </div>
  );
};

export default UserBadge;
